import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

type Props = {
    labelWidth?: number | string
    valueWidth?: number | string
}

export default function SkeletonField(props: Readonly<Props>) {
    const { labelWidth = '35%', valueWidth = '60%' } = props

    return (
        <Stack spacing={0.5} sx={{ width: '100%' }}>
            <Skeleton variant="text" width={labelWidth} sx={{ fontSize: '0.75rem' }} />
            <Box sx={{ borderBottom: '1px solid', borderColor: 'divider', pb: 0.5 }}>
                <Skeleton variant="text" width={valueWidth} sx={{ fontSize: '1rem' }} />
            </Box>
        </Stack>
    )
}
